/* requires:
polyfill.js
pricing.js
*/

const bulkRateModal = {
  modal: document.querySelector('#bulk-rate-modal'),

  formatAmount: (number) => {
    return Number(Math.round(number + 'e2') + 'e-2');
  },

  loadProductData: async () => {
    const triggers = [...document.querySelectorAll('.bulk-rates-trigger[data-pid]')];
    if (!triggers.length) return;

    // Use cached data if bulk-order-form.js already fetched it
    const cached = sessionStorage.getItem('productsData');
    let products;

    if (cached) {
      products = JSON.parse(cached);
    } else {
      const productAPIUrl = 'product_api_url_replaced_during_build';
      const unpublishedData = 'product_unpublished_replaced_during_build';
      const defaultHost = 'default_host_replaced_during_build';
      const defaultGroupId = 'default_group_replaced_during_build';
      const queryTestPrice = pricing.getQueryString('tp') || pricing.readCookie('_up4tp') || null;
      const queryGroupId =
        pricing.getQueryString('gid') ||
        pricing.getQueryString('lgr') ||
        pricing.readCookie('_up4gid') ||
        defaultGroupId ||
        null;
      const queryCoupon = pricing.getQueryString('cc') || pricing.readCookie('_up4cc') || null;

      const testPriceQuery = queryTestPrice ? `&testPrice=${queryTestPrice}` : '';
      const groupIdQuery = queryGroupId ? `&groupId=${queryGroupId}` : '';
      const couponQuery = queryCoupon ? `&couponcode=${queryCoupon}` : '';
      const unpublishedQuery = `&unpublished=${unpublishedData}`;

      const productAPI = `${productAPIUrl}/GetProductsBy/?host=${defaultHost}${testPriceQuery}${groupIdQuery}${couponQuery}${unpublishedQuery}&fullSiteBuild=true`;

      try {
        const res = await fetch(productAPI);
        if (!res.ok) return;
        products = await res.json();
      } catch (e) {
        return;
      }
    }

    for (let trigger of triggers) {
      const product = products.find((p) => p.id === trigger.dataset.pid);
      if (!product) continue;
      trigger.dataset.productName = product.name;
      trigger.dataset.bulkRates = JSON.stringify(product.productBulkTiers || '[]');
    }
  },

  populate: (trigger) => {
    const modal = bulkRateModal.modal;
    const modalTitle = modal.querySelector('.product-name');
    const bulkRateInfoDisplay = modal.querySelector('.bulk-rate-info');

    modalTitle.innerHTML = trigger.dataset.productName;

    const bulkRates = JSON.parse(trigger.dataset.bulkRates || '[]');
    const discountMsgEl = modal.querySelector('.modal-discounts-msg');

    if (bulkRates && bulkRates.length > 0) {
      let bulkRateInfo = '';
      for (let i = 0; i < bulkRates.length; i++) {
        const bulkPrice = bulkRateModal.formatAmount(bulkRates[i].discountTierUnitPrice).toFixed(2);
        if (i < bulkRates.length - 1) {
          const tier = `${bulkRates[i].minQuantity}-${bulkRates[i + 1].minQuantity - 1}`;
          bulkRateInfo += `Buy ${tier} and get a unit price of $${bulkPrice}<br/>`;
        } else {
          const tier = `${bulkRates[i].minQuantity} or more`;
          bulkRateInfo += `Buy ${tier} and get a unit price of $${bulkPrice}`;
        }
      }
      bulkRateInfoDisplay.innerHTML = bulkRateInfo;

      const isCouponApplied =
        typeof cart !== 'undefined' && cart.getLocalCart()?.cartProducts?.some((p) => p?.discountSource === 'Coupon');

      if (isCouponApplied) {
        if (!discountMsgEl) {
          bulkRateInfoDisplay.insertAdjacentHTML(
            'afterend',
            '<p class="modal-discounts-msg small text-muted fst-italic mt-2 mb-0">Other discounts may be applied in the cart</p>'
          );
        }
      } else {
        discountMsgEl && discountMsgEl.remove();
      }
    } else {
      bulkRateInfoDisplay.innerHTML = `<em>Contact us to speak to a sales representative for bulk pricing.</em>`;
    }
  },

  init: async () => {
    if (!bulkRateModal.modal) return;

    await bulkRateModal.loadProductData();

    // Bootstrap native triggers (data-bs-toggle="modal") fire this before opening
    bulkRateModal.modal.addEventListener('show.bs.modal', (event) => {
      if (event.relatedTarget) {
        bulkRateModal.populate(event.relatedTarget);
      }
    });

    // Manual triggers (no data-bs-toggle) — mirrors bulk-order-form.js behavior
    const bsModal = new bootstrap.Modal('#bulk-rate-modal');
    const manualTriggers = [...document.querySelectorAll('.bulk-rates-trigger:not([data-bs-toggle])')];

    const showModal = (event) => {
      const trigger = event.target.closest('.bulk-rates-trigger');
      if (!trigger) return;
      if (event.key === ' ') event.preventDefault();
      bulkRateModal.populate(trigger);
      bsModal.show();
    };

    for (let trigger of manualTriggers) {
      trigger.addEventListener('click', showModal);
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') showModal(e);
      });
    }
  },
};

bulkRateModal.init();
